import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getFaqUrl} from 'presentation/pages/private/help/services/getFaqUrl';

const useGetFaqUrlQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.FAQ_URL],
		queryFn: ({signal}) => getFaqUrl({signal}),
		enabled: false,
	});

export {useGetFaqUrlQuery};
